import React, { Component } from 'react';

class CheckboxComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
    }
  }

  render() {
    const { index, input, label, meta: { error } } = this.props;
    const checked = this.state.checked;
    return (
      <>
        <label className="checkbox-container">{label}
          <input name={`${input.name}[${index}]`} type="checkbox" value={true} checked={checked} onChange={event => {
            this.setState({ checked: event.target.checked });
            return input.onChange(event.target.checked);
          }} />
          <span className="checkmark">
            {/* <FontAwesomeIcon icon={["fas", "square-full"]} /> */}
            <div className="checkmark-icon"></div>
          </span>
        </label>
        {error && <span>{error}</span>}
      </>
    );
  }
}

export default CheckboxComponent;